"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStream = void 0;
class DataStream {
    constructor(buffer) {
        this.buffer = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
        this.cursor = 0;
    }
    isEndOfStream() {
        return this.cursor >= this.buffer.byteLength;
    }
    readUint8() {
        const value = this.buffer.getUint8(this.cursor);
        this.cursor += 1;
        return value;
    }
    readUint16() {
        const value = this.buffer.getUint16(this.cursor, false);
        this.cursor += 2;
        return value;
    }
    readUint32() {
        const value = this.buffer.getUint32(this.cursor, false);
        this.cursor += 4;
        return value;
    }
    readUint64() {
        const value = this.buffer.getBigUint64(this.cursor, false);
        this.cursor += 8;
        return value;
    }
    readFloat32() {
        const value = this.buffer.getFloat32(this.cursor, false);
        this.cursor += 4;
        return value;
    }
    readFloat64() {
        const value = this.buffer.getFloat64(this.cursor, false);
        this.cursor += 8;
        return value;
    }
    readBytes(bytes) {
        const begin = this.buffer.byteOffset + this.cursor;
        this.cursor += bytes;
        return new Uint8Array(this.buffer.buffer, begin, bytes);
    }
}
exports.DataStream = DataStream;
